import { Component, EventEmitter, Input, Output, input } from '@angular/core';
import { AppstateService } from 'src/app/services/appstate.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { CustomMenuItem } from 'src/app/types/infrastructure/CustomMenuItem';

@Component({
  selector: 'app-page-panel',
  templateUrl: './page-panel.component.html',
  styleUrl: './page-panel.component.scss'
})
export class PagePanelComponent {

  @Input() pageTitle: string = '';
  @Input() iconNameIonicon: string = '';
  @Input() iconNameFontAwesome: string = '';

  @Input() customButton1Title: string = '';
  @Input() customButton2Title: string = '';
  @Input() customButton3Title: string = '';
  @Input() customButton4Title: string = '';
  @Input() customButton5Title: string = '';

  @Input() customMenuButton1Title: string = '';
  @Input() customMenuButton1Items: CustomMenuItem[] = [];
  @Input() iconMenuButtons: CustomMenuItem[] = [];
  @Input() iconMenuOffset: string = ''; 
  @Input() customMenuButton1Tooltip: string | undefined;

  @Input() customButton1Tooltip: string | undefined 
  @Input() customButton2Tooltip: string | undefined;
  @Input() customButton3Tooltip: string | undefined;
  @Input() customButton4Tooltip: string | undefined;
  @Input() customButton5Tooltip: string | undefined;

  @Input() showBackButton: boolean = true;
  @Input() showCheckedButton: boolean = false;
  @Input() showInfoButton: boolean = false;
  @Input() showEditButton: boolean = false;
  @Input() showDeleteButton: boolean = false;
  @Input() showHistoryButton: boolean = false;
  @Input() showDetailsButton: boolean = true;
  @Input() showSidepanelButton: boolean = true;
  @Input() showCloseButton: boolean = false;
  @Input() showBackColor: boolean = false;
  @Input() showContent: boolean = true;
  @Input() resizeContent: boolean = false;
  
  @Output() backButtonClicked: EventEmitter<any> = new EventEmitter();
  @Output() customButton1Clicked: EventEmitter<any> = new EventEmitter();
  @Output() customButton2Clicked: EventEmitter<any> = new EventEmitter();
  @Output() customButton3Clicked: EventEmitter<any> = new EventEmitter();
  @Output() customButton4Clicked: EventEmitter<any> = new EventEmitter();
  @Output() customButton5Clicked: EventEmitter<any> = new EventEmitter();
  @Output() customMenuButton1ItemClicked: EventEmitter<CustomMenuItem> = new EventEmitter<CustomMenuItem>();
  @Output() iconMenuButtonClicked: EventEmitter<CustomMenuItem> = new EventEmitter<CustomMenuItem>();
  
  @Output() checkedButtonClicked: EventEmitter<any> = new EventEmitter();
  @Output() infoButtonClicked: EventEmitter<any> = new EventEmitter();
  @Output() editButtonClicked: EventEmitter<any> = new EventEmitter();
  @Output() deleteButtonClicked: EventEmitter<any> = new EventEmitter();
  @Output() historyButtonClicked: EventEmitter<any> = new EventEmitter();
  @Output() detailsButtonClicked: EventEmitter<any> = new EventEmitter();
  @Output() closeButtonClicked: EventEmitter<any> = new EventEmitter();

  constructor(public appStateService: AppstateService,
              public navigationService: NavigationService) { 

  }

  button_back_clicked() {
    this.backButtonClicked.emit();
  }

  button_custom1_clicked() {
    this.customButton1Clicked.emit();
  }

  button_custom2_clicked() {
    this.customButton2Clicked.emit();
  }

  button_custom3_clicked() {
    this.customButton3Clicked.emit();
  }

  button_custom4_clicked() {
    this.customButton4Clicked.emit();
  }

  button_custom5_clicked() {
    this.customButton5Clicked.emit();
  }

  iconMenuButton_clicked(item: CustomMenuItem | undefined) {
	if( item && (item.route || item.route == '_')){
		this.navigationService.navigateFromBudgetantrag(this.iconMenuOffset,item.route);
	} else {
		this.iconMenuButtonClicked.emit(item);
	}
 }
  
  button_custom_menu1_item_click(item: CustomMenuItem) {
    this.customMenuButton1ItemClicked.emit(item);
  }

  button_checked_clicked(){
    this.checkedButtonClicked.emit();
  }

  button_info_clicked(){
    this.infoButtonClicked.emit();
  }

  button_edit_clicked(){
    this.editButtonClicked.emit();
  }

  button_delete_clicked(){
    this.deleteButtonClicked.emit();
  }

  button_history_clicked(){
    this.navigationService.toggleSidepanelHistory();
  }

  button_details_clicked(){
    this.detailsButtonClicked.emit();
  }
  
  button_sidepanel_clicked() {
    this.navigationService.toggleSidepanelInfo();
  }

  button_close_clicked() {
    this.closeButtonClicked.emit();
  }
}
